import React from 'react';
import PropTypes from 'prop-types';

import { DiscountSection, DiscountHeading, DiscountDescription, DiscountContainer, DiscountDish, DiscountCodeContainer, DiscountCode, DiscountSub } from './styles';

const BookingDiscount = ({ code, percent, description, twoColumn }) => (
  <DiscountSection twoColumn={twoColumn}>
    <DiscountHeading>{percent}% Off</DiscountHeading>
    {description && <DiscountDescription dangerouslySetInnerHTML={{ __html: description }} />}
    <DiscountContainer>
      <DiscountDish />
      <DiscountCodeContainer>
        <DiscountCode>{code}</DiscountCode>
        <DiscountSub>promo code</DiscountSub>
      </DiscountCodeContainer>
    </DiscountContainer>
  </DiscountSection>
);

BookingDiscount.propTypes = {
  code: PropTypes.string,
  percent: PropTypes.number,
  description: PropTypes.string,
  twoColumn: PropTypes.bool,
};

export default BookingDiscount;
